export default __webpack_public_path__ + "static/media/emoji.b62a950b.png";